export default __webpack_public_path__ + "static/media/simpleLoader.c23ef176.svg";